import { render, staticRenderFns } from "./QuestionDelete.vue?vue&type=template&id=da55a580&scoped=true&"
import script from "./QuestionDelete.vue?vue&type=script&lang=js&"
export * from "./QuestionDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da55a580",
  null
  
)

export default component.exports